/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuoteReportRules
 */
export interface QuoteReportRules {
    /**
     * 
     * @type {boolean}
     * @memberof QuoteReportRules
     */
    allowPercentage: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteReportRules
     */
    allowExcludeComplaintsSection: boolean;
}

/**
 * Check if a given object implements the QuoteReportRules interface.
 */
export function instanceOfQuoteReportRules(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "allowPercentage" in value;
    isInstance = isInstance && "allowExcludeComplaintsSection" in value;

    return isInstance;
}

export function QuoteReportRulesFromJSON(json: any): QuoteReportRules {
    return QuoteReportRulesFromJSONTyped(json, false);
}

export function QuoteReportRulesFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteReportRules {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowPercentage': json['AllowPercentage'],
        'allowExcludeComplaintsSection': json['AllowExcludeComplaintsSection'],
    };
}

export function QuoteReportRulesToJSON(value?: QuoteReportRules | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AllowPercentage': value.allowPercentage,
        'AllowExcludeComplaintsSection': value.allowExcludeComplaintsSection,
    };
}

